export default "__VITE_ASSET__CU9$2MBJ__"